import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Master from "../views/Master.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Master",
    component: Master
  },
  {
    path: "/receipt",
    name: "Receipt",
    component: () =>
      import(/* webpackChunkName: "receipt" */ "../views/Receipt.vue")
  },
  {
    path: "/aggregate",
    name: "Aggregate",
    component: () =>
      import(/* webpackChunkName: "aggregate" */ "../views/Aggregate.vue")
  },
  {
    path: "/medical/specification",
    name: "MedicalSpecification",
    component: () =>
      import(
        /* webpackChunkName: "medical_specification" */ "../views/MedicalSpecification.vue"
      )
  },
  {
    path: "/medical/insinvoice",
    name: "MedicalInsInvoice",
    component: () =>
      import(
        /* webpackChunkName: "medical_insinvoice" */ "../views/MedicalInsInvoice.vue"
      )
  },
  {
    path: "/medical/userinvoice",
    name: "MedicalUserInvoice",
    component: () =>
      import(
        /* webpackChunkName: "medical_userinvoice" */ "../views/MedicalUserInvoice.vue"
      )
  },
  {
    path: "/medical/edit/:id",
    name: "MedicalEdit",
    component: () =>
      import(/* webpackChunkName: "medical_edit" */ "../views/MedicalEdit.vue")
  },
  {
    path: "/medical/merge",
    name: "MedicalMerge",
    component: () =>
      import(
        /* webpackChunkName: "medical_merge" */ "../views/MedicalMerge.vue"
      )
  },
  {
    path: "/medical/summarytable",
    name: "SummaryTable",
    component: () =>
      import(
        /* webpackChunkName: "summary_table" */ "../views/SummaryTable.vue"
      )
  },
  {
    path: "/care/specification",
    name: "CareSpecification",
    component: () =>
      import(
        /* webpackChunkName: "care_specification" */ "../views/CareSpecification.vue"
      )
  },
  {
    path: "/care/insinvoice",
    name: "CareInsInvoice",
    component: () =>
      import(
        /* webpackChunkName: "care_insinvoice" */ "../views/CareInsInvoice.vue"
      )
  },
  {
    path: "/care/userinvoice",
    name: "CareUserInvoice",
    component: () =>
      import(
        /* webpackChunkName: "care_userinvoice" */ "../views/CareUserInvoice.vue"
      )
  },
  {
    path: "/care/edit/:id",
    name: "CareEdit",
    component: () =>
      import(/* webpackChunkName: "care_edit" */ "../views/CareEdit.vue")
  },
  {
    path: "/care/csv",
    name: "CareCsv",
    component: () =>
      import(/* webpackChunkName: "care_csv" */ "../views/CareCsv.vue")
  },
  {
    path: "/care/merge",
    name: "CareMerge",
    component: () =>
      import(/* webpackChunkName: "care_merge" */ "../views/CareMerge.vue")
  },
  {
    path: "/care/transmission",
    name: "TransmissionInlineFrame",
    component: () =>
      import(/* webpackChunkName: "care_transmission" */ "../views/TransmissionInlineFrame.vue")
  },
  {
    path: "/settings",
    name: "Settings",
    component: () =>
      import(/* webpackChunkName: "settings" */ "../views/Settings.vue")
  },
  {
    path: "/commingsoon",
    name: "Commingsoon",
    component: () =>
      import(/* webpackChunkName: "commingsoon" */ "../views/Commingsoon.vue")
  },
  {
    path: "/userinvoice",
    name: "UserInvoice",
    component: () =>
      import(/* webpackChunkName: "user_invoice" */ "../views/UserInvoice.vue")
  },
  {
    path: "/userinvoice/edit/:id",
    name: "UserInvoiceEdit",
    component: () =>
      import(/* webpackChunkName: "user_invoice_edit" */ "../views/UserInvoiceEdit.vue")
  },
  {
    path: "/all_no_output",
    name: "AllNoOutput",
    component: () =>
      import(/* webpackChunkName: "all_no_output" */ "../views/AllNoOutput.vue")
  },
  {
    path: "/payment_manage",
    name: "PaymentManage",
    component: () =>
      import(
        /* webpackChunkName: "payment_manage" */ "../views/PaymentManage.vue"
      )
  },
  {
    path: "/billinglist",
    name: "BillingList",
    component: () =>
      import(
        /* webpackChunkName: "billinglist" */ "../views/BillingList.vue"
      )
  },
  {
    path: "/billinglistdetails",
    name: "BillingListDetails",
    component: () =>
      import(
        /* webpackChunkName: "billinglistdetails" */ "../views/BillingListDetails.vue"
      )
  },
  {
    path: "/account_transfer",
    name: "AccountTransferManage",
    component: () =>
      import(
        /* webpackChunkName: "account_transfer" */ "../views/AccountTransferManage.vue"
      )
  },
  {
    path: "/operationlog",
    name: "Operationlog",
    component: () =>
      import(
        /* webpackChunkName: "operationlog" */ "../views/OperationLog.vue"
      )
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

export default router;
